const resource = 'statistics'

export default (axios) => ({
  count (params) {
    return axios.get(`${resource}/count`, params)
  },
})
